export const CATEGORIAS = ["Assédio Moral", "Assédio Sexual", "Abuso de poder", "Conduta Antiética", "Reclamações em Geral", "Apelação"];
export const CATEGORIAS_IDENTIFICACAO_OBRIGATORIA = ["Reclamações em Geral", "Apelação"];
export const PROTOCOLO_LENGTH = 8;
export const MAX_PROTOCOLO_ATTEMPTS = 5;
export const MAX_ANEXOS = 10;
export const MAX_ANEXO_SIZE_BYTES = 20 * 1024 * 1024;
export const ALLOWED_ANEXO_TYPES = ['application/pdf'];
export const ALLOWED_ANEXO_PREFIXES = ['image/', 'audio/'];
